export default __webpack_public_path__ + "static/media/pexels-photo-2885320RobertoNickson.3220cfea.jpeg";